module.exports = __webpack_public_path__ + "media/ring.0f23.mp3";